import { useState } from 'react';
import Header from '../../../../customs/Header';
import SettingsModal from '../Modal/settingsCustomModal';
import ApprovalTypeContent from './ApprovalTypeContent';
import CreateApprovalType from './CreateApprovalType';

export default function ApprovalType() {
  const [openCreateApprovalTypeModal, setOpenCreateApprovalTypeModal] = useState(false);

  const handleOpenCreateApprovalTypeModal = () => setOpenCreateApprovalTypeModal(true);
  const handleCloseCreateApprovalTypeModal = () => setOpenCreateApprovalTypeModal(false);

  return (
    <section>
      <Header props={
        { 
          firstName: 'All', 
          secondName: 'Approval Type', 
          buttonText: 'Create Approval Type'
        }}
        handleOpen={handleOpenCreateApprovalTypeModal}
      />

      <ApprovalTypeContent />

      <SettingsModal
        open={openCreateApprovalTypeModal}
        cancel={handleCloseCreateApprovalTypeModal}
        maxWidth='480px'
        header='Create Approval Type'
        showrightIcon={false}
        content={<CreateApprovalType handleClose={handleCloseCreateApprovalTypeModal}/>}      
      />

    </section>
  )
}
